import styled from 'styled-components';
import theme from '../theme';

export const StyledPrimaryHeaderWrapper = styled.thead<{
  $hideShadow: boolean;
}>`
  position: relative;
  ${({ $hideShadow }) =>
    $hideShadow
      ? ''
      : `&:before {
        content: '';
        width: 100%;
        height: 47px;
        position: absolute;
        top: 0;
        left: 0;
        box-shadow: ${theme.getElevation('bottom')};
        pointer-events: none;
        z-index: 1;`}
`;

export const StyledPrimaryHeaderRow = styled.tr`
  position: relative;
`;

export const StyledPrimaryHeaderCell = styled.th`
  && {
    background-color: white;
    letter-spacing: 0.2px;
    color: ${theme.textColorSecondary};
    text-transform: none;
    padding: 12px 16px;
    white-space: nowrap;
  }
  .ant-table-filter-trigger.active {
    .anticon {
      color: ${theme.blue6};
    }
  }
`;

export const StyledPrimaryBodyCell = styled.td`
  && {
    padding: 12px 16px;
  }
`;
